<template>
  <div class="login-container">
    <div class="box">
      <div class="box-left"></div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
        <h3 class="title">收银通商户登录</h3>
        <el-form-item prop="name">
          <el-input v-model="loginForm.name" placeholder="账号" name="name" type="text" />
        </el-form-item>
        <el-form-item prop="password" class="pwd-box">
          <el-input v-model="loginForm.password" :type="pwdType" placeholder="密码" name="password" />
          <svg-icon class="icon" :iconClass="pwdIcon" @click="changePwd"></svg-icon>
        </el-form-item>
        <el-form-item prop="captcha" class="code">
          <el-input v-model="loginForm.captcha" placeholder="验证码" name="captcha" type="text" @keyup.enter.native="doLogin"/>
          <img class="code-area" v-if="loginForm.codeImg" :src="loginForm.codeImg" alt @click="getCodeImg" />
          <div class="code-area" v-else />
        </el-form-item>
        <el-button class="btn" :disabled="disabledBtn" :loading="loading" type="primary" @click.native.prevent="doLogin">登录</el-button>
        <div class="op">
          <div class="tips" @click="appQrcodeVisible = true">APP下载</div>
          <div class="tips" @click="goModifyPwd">忘记密码</div>
        </div>
      </el-form>
      <el-dialog
        title=""
        :visible.sync="appQrcodeVisible"
        width="520px"
        top="0"
        custom-class="app-qr-div">
        <p class="title">扫码下载APP</p>
        <div class="code-div">
          <div>
            <img src="../../assets/images/login/app-qrx.png" alt=""/>
            <p>收银通商户版</p>
          </div>
          <div>
            <img src="../../assets/images/login/app-qr2x.png" alt=""/>
            <p>收银通展业版</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getCaptcha, userLogin, getUserInfo, queryMenuList, queryCloudManageConfig, getSignDetail,
} from '@/api/login';
import { queryOnlinePermission } from '@/api/collection-bill';
import { userLoginError } from '@/utils';
import { getAuthorityServer } from "../../api/cloud-manage";

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 8 || value.length > 16) {
        callback(new Error('密码必须是8-16个字符'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        name: '',
        nameType: 1, // 名称类型为用户名
        passType: 1, // 密码类型为密码模式， pass = md5(md5(userpass)+salt(timestamp))
        password: '',
        captcha: '', // 输入图形验证码中数字
        captchaKey: '', // 图形验证码的key
        codeImg: '',
      },
      loginRules: {
        name: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        captcha: [{ required: true, trigger: 'blur', validator: validateCode }],
      },
      loading: false,
      pwdType: 'password',
      pwdIcon: 'hide-pwd',
      appQrcodeVisible: false,
    };
  },
  computed: {
    disabledBtn() {
      return !(this.loginForm.name && this.loginForm.password.length >= 8 && this.loginForm.password.length <= 16 && this.loginForm.captcha);
    },
    accessRoutes() {
      return this.$store.state.permission.addRoutes;
    },
  },
  methods: {
    changePwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
        this.pwdIcon = "show-pwd";
      } else {
        this.pwdType = "password";
        this.pwdIcon = "hide-pwd";
      }
    },
    doLogin() {
      this.$refs.loginForm.validate(async (valid, error) => {
        if (valid) {
          this.loading = true;
          const loginRes = await this.userLogin();
          if (loginRes && typeof loginRes === 'string') {
            await this.getUserInfo(loginRes);
          }
          this.loading = false;
        } else {
          console.log(error);
        }
      });
    },
    goModifyPwd() {
      this.$router.push({ path: '/forgetPwd' });
    },
    getCodeImg() {
      getCaptcha().then((res) => {
        if (res.data.code === 0) {
          this.loginForm.codeImg = res.data.captcha_url;
          this.loginForm.captchaKey = res.data.captcha_key.replace('SIMP:', '');
        }
      });
    },
    userLogin() {
      const time = new Date().getTime();
      const salt = `YK${time}MS`;
      const psdMd5 = (this.$md5(this.loginForm.password)).toUpperCase();
      const pass = `${salt}|${this.$md5(psdMd5 + salt)}`;
      const params = Object.assign({}, this.loginForm, {
        pass,
        password: '',
        codeImg: '',
      });
      return new Promise((resolve, reject) => {
        userLogin(params).then((res) => {
          const code = res.data.code;
          if (code === 0) {
            this.$store.state.app.visitedViews.splice(0, this.$store.state.app.visitedViews.length);
            resolve(res.data.uatk);
          }
        }).catch((res) => {
          const code = res.data.code;
          if ([10020, 10022].includes(code)) {
            // 图形验证码校验不正确
            this.getCodeImg();
          }
          const msg = userLoginError(res.data.code);
          this.$message({
            showClose: true,
            message: msg,
            type: 'warning',
          });
          resolve(false);
        });
      });
    },
    getUserInfo(sessionId) {
      const params = {
        userName: this.loginForm.name,
        sessionId,
      };
      return new Promise((resolve, reject) => {
        getUserInfo(params).then(async ({ data: { error_code: code, data } }) => {
          const { merchantId, saasMerchant, authorityList } = data;
          if (code === 0) {
            localStorage.setItem('LOGIN_INFO', JSON.stringify({ ...data, sessionId }));
            localStorage.setItem('authRoute', JSON.stringify(authorityList || {}));
            // copilot begin
            // 获取所有需要的权限数据
            const { data: { data: permissionData } } = await queryOnlinePermission({ merchantId, sessionId });
            const { data: { data: cloudManagePermission } } = await getAuthorityServer({});
            // 存储权限数据到 localStorage
            localStorage.setItem('CB_PERMISSION', permissionData !== '{}' ? JSON.stringify(permissionData) : -1019);
            localStorage.setItem('CP_PERMISSION', JSON.stringify(cloudManagePermission || []));
            localStorage.setItem('SAAS_MERCHANT', JSON.stringify(saasMerchant || 0)); // 0-表示非saas特殊商户  1-表示是，如果是1的话，就把菜单都隐藏起来，只展示云管家的菜单
            // copilot end

            /**
             * 新的菜单控制
             * 2022年8月23日15:50:46
             * */
            const { data: { code, data: menuList = [] } } = await queryMenuList();
            localStorage.setItem('menuList', JSON.stringify(code === '0' ? menuList : []));
            this.$store.dispatch('permission/generateRoutes');
            this.$router.options.routes = this.$router.options.routes.concat(this.accessRoutes);
            this.$router.addRoutes(this.accessRoutes);

            /**
             * SaaS商户+白名单 默认展示云管家首页地址
             * 2024年6月25日
             * */
            this.$router.push({ path: (cloudManagePermission.length > 0 ? '/cloud-manage/split-account/open' : 'flow-new/index') });
            // 等二期功能上线再开启协议弹窗
            // getSignDetail().then((res) => {
            //   if (res.data.error_code === 0) {
            //     const { status } = res.data.data;
            //     if (![2, 4].includes(status)) {
            //       const message = '<div sytyle="text-align: left">尊敬的用户，您还未与乐刷签署商户收单协议，请您在<span style="font-weight: bold">【乐刷收银通APP】</span><span style="color: red">尽快签署《特约商户支付服务合作协议》</span>。如未及时签署，后续可能会影响您的<span style="color: red">限额</span>或<span style="color: red">交易</span>！</div>';
            //       this.$confirm(message, "特约商户支付服务合作协议签署提醒", {
            //         dangerouslyUseHTMLString: true,
            //         showClose: false,
            //         center: true,
            //         closeOnClickModal: false,
            //         confirmButtonText: "我已知晓",
            //         showCancelButton: false,
            //         confirmButtonClass: 'bs-btn',
            //       });
            //     }
            //   }
            // });
          }
          resolve(code === 0);
        }).catch((e) => {
          reject(e);
        });
      });
    },
  },
  created() {
    this.getCodeImg();
  },
};
</script>


<style lang="scss">
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url(../../assets/images/login/bg2.png);
  background-repeat: repeat-x;
  background-attachment: fixed;
  background-size: 100% 100%;

  .box {
    display: flex;
    width: 810px;
    height: 515px;
    background-color: #fff;
    border-radius: 8px;

    .box-left {
      width: 350px;
      background: url(../../assets/images/login/banner.png) no-repeat;
    }

    .login-form {
      width: 460px;
      padding: 0 60px;
      text-align: center;

      .pwd-box {
        position: relative;

        .icon {
          position: absolute;
          right: 0;
          bottom: 7px;
          width: 20px;
          height: 16px;
        }
      }

      .el-form-item {
        margin: 0;
      }

      h3 {
        margin-top: 47px;
        font-size: 24px;
        font-weight: bold;
        color: #27364d;
      }

      input {
        width: 100%;
        height: 30px;
        padding: 0;
        margin-top: 48px;
        font-size: 16px;
        font-weight: 400;
        color: #27364d;
        vertical-align: middle;
        background-color: #fff;
        border: 0;
        border-bottom: 1px solid #ddd;
        border-radius: 0;
        outline: 0;
        caret-color: #008cff;

        &:focus {
          border-bottom: 1px solid #008cff;
        }
      }

      .el-button {
        border: none;
      }

      // 清除自动填充背景色
      input:-webkit-autofill {
        transition: background-color 5000s ease-in-out 0s;
      }

      .code {
        .el-form-item__content {
          display: flex;
          align-items: flex-end;

          input {
            width: 190px;
          }

          .code-area {
            flex-shrink: 0;
            width: 140px;
            height: 48px;
            margin-left: 10px;
            cursor: pointer;
            border-radius: 8px;
          }
        }
      }

      .btn {
        width: 340px;
        height: 60px;
        margin: 43px 0 40px;
        font-size: 20px;
        font-weight: 500;
        color: #eff4f8;
        background: linear-gradient(90deg, #51b2f7, #2d66f5);
        border-radius: 8px;
        box-shadow: 0 4px 8px 0 rgba(0, 140, 255, 0.2);
      }

      .op {
        display: flex;
        justify-content: space-between;

        .tips {
          font-size: 16px;
          color: #666;
          cursor: pointer;
        }
      }
    }
  }

  .app-qr-div {
    top: 50%;
    width: 520px;
    height: 395px;
    text-align: center;
    border-radius: 8px;
    transform: translateY(-50%);

    .title {
      margin: 0 0 53px;
      font-size: 24px;
      font-weight: bold;
      color: #27364d;
    }

    .code-div {
      display: flex;
      justify-content: center;

      img {
        width: 210px;
        height: 210px;
      }

      p {
        margin: -15px 0 0;
        font-size: 16px;
        color: #7f8594;
      }
    }
  }
}

</style>
